import { Card, CardBody, Col } from "reactstrap";
import { ActiveDisablePageTitle } from "../../../../Constants/Constants";
import { ActiveDisableSubTitle, DefaultPageData } from "../../../../Data/BonusUi/Pagination";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DefaultPaginationList from "../Common/DefaultPaginationList";

const ActiveDisablePage = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={ActiveDisablePageTitle} span={ActiveDisableSubTitle} />
        <CardBody>
          <DefaultPaginationList pageColor="success" data={DefaultPageData} active disabled/>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ActiveDisablePage;
